import React from "react";

/** Data provided by the {@link HIGHLIGHT_CONTEXT} */
export type HighlightContext = {
    /** Search term to highlight. Is `toLowerCase()` */
    searchTerm: string;
};

/** {@link React.Context} to access the highlight functionality. */
const HIGHLIGHT_CONTEXT = React.createContext<HighlightContext>({
    searchTerm: "",
});
HIGHLIGHT_CONTEXT.displayName = "Highlight";
export default HIGHLIGHT_CONTEXT;
